import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CreatorForm from "./Pages/Creator_Form";
import Home from "./Pages/Home";
import Signin from "./Pages/Signin";
import Signup from "./Pages/Signup";
import Playlists from "./Pages/Playlist/Playlists";
import Creator from "./Pages/Creator_Page";
import CreatorDash from "./Pages/CreatorsDash";
import ForgotPassword from "./Pages/forgotpassword";
import NewCredentials from "./Pages/newcredentials";
import CategoricalSearch from "./Pages/Playlist/CategoricalSearch";
import UserProfile from "./Pages/userProfile";
import Search from "./Pages/search/index";
import TOC from "./Pages/Terms";
import ShowOpportunity from "./Pages/Opportunity/ShowOpportunity";
import Settings from "./Components/CreatorsDash/Settings";



const RoutesFile = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/signin" exact element={<Signin />} />
          <Route path="/opportunity" exact element={<ShowOpportunity />} />

          <Route path="/signup" exact element={<Signup />} />
          <Route path="/creatorform" exact element={<CreatorForm />} />
          <Route path="/playlists" exact element={<Playlists />} />
          <Route path="/settings" element={<Settings />} />

          <Route
            path="/creator/:creatorName/:lang/:name/:id"
            exact
            element={<Creator />}
          />
          <Route path="/dash" exact element={<CreatorDash />} />
          <Route path="/profile" exact element={<UserProfile />} />
          <Route path="/forgotpassword" exact element={<ForgotPassword />} />
          <Route
            path="/newcredentials/:token"
            exact
            element={<NewCredentials />}
          />
          <Route path="/:pagetype/:id" exact element={<CategoricalSearch />} />

          <Route path="/search" exact element={<Search />} />
          <Route path="/termsandconditions" exact element={<TOC />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default RoutesFile;
